export const Pokedex: {[k: string]: ModdedSpeciesData} = {
	genesectdouse: {
		inherit: true,
		types: ["Bug", "Water"],
	},
	genesectshock: {
		inherit: true,
		types: ["Bug", "Electric"],
	},
	genesectburn: {
		inherit: true,
		types: ["Bug", "Fire"],
	},
	genesectchill: {
		inherit: true,
		types: ["Bug", "Ice"],
	},
};
